/*
  SAVRA footer legal bar — Cookie Preferences reveal-on-availability.
  Shopify's reopenable Customer Privacy banner (window.privacyBanner,
  loaded by Shopify's own storefront-banner.js when that integration is
  configured) is feature-detected once at page load. No polling, no
  fabricated fallback UI, no direct cookie reads/writes. If it isn't
  present, the button stays hidden for this pageview rather than
  becoming a dead control — this store's confirmed real privacy resource
  today is the Shopify-generated "Your Privacy Choices" page, linked
  separately in snippets/footer-legal.liquid.
*/
(function () {
  'use strict';
  var btn = document.querySelector('[data-cookie-preferences]');
  if (!btn) return;

  if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
    btn.hidden = false;
    btn.addEventListener('click', function () {
      window.privacyBanner.showPreferences().catch(function () {
        // Fail silently — never surface a raw API error to the customer.
      });
    });
  }
})();
